export default function CTASection() {
  return (
    <section className="relative overflow-hidden">
      <div className="flex flex-col lg:flex-row">
        <div className="flex-1 relative min-h-[300px] lg:min-h-[450px]">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20warm%20cream%20and%20soft%20sand%20tones%2C%20overlapping%20organic%20geometric%20shapes%20with%20subtle%20sage%20green%20accents%2C%20modern%20minimalist%20gallery%20wall%20aesthetic%2C%20sophisticated%20matte%20textures%20with%20delicate%20gradient%20transitions%2C%20abundant%20negative%20space%20and%20refined%20contemporary%20design&width=900&height=600&seq=cta-v2-bg-001&orientation=landscape"
            alt="AllChinaBuy Spreadsheet CTA background"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/50 to-transparent"></div>
          <div className="absolute inset-0 flex flex-col justify-end p-8 md:p-12">
            <p className="text-background-100/80 text-xs md:text-sm font-medium tracking-wide mb-2">Start Today</p>
            <p className="text-background-50 text-2xl md:text-4xl font-heading font-bold leading-tight">
              Save Time
            </p>
            <p className="text-background-50 text-2xl md:text-4xl font-heading font-bold leading-tight">
              Save Money
            </p>
            <p className="text-background-50 text-2xl md:text-4xl font-heading font-bold leading-tight">
              Shop Smart
            </p>
          </div>
        </div>

        <div className="flex-1 flex items-center justify-center bg-background-100 p-8 md:p-16 min-h-[300px] lg:min-h-[450px]">
          <div className="text-center max-w-md">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-2">
              Get The Sheet
            </h2>
            <p className="text-lg md:text-2xl font-heading font-semibold text-primary-600 mb-4">
              AllChinaBuy 2026
            </p>
            <p className="text-sm md:text-base text-foreground-600 mb-8 leading-relaxed">
              Start exploring the latest AllChinaBuy Spreadsheet and discover the best finds today. Updated weekly with fresh links, verified sellers, and exclusive deals.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all hover:scale-[1.02] whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
              >
                Buy It Now
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-900 text-background-50 rounded-full text-base font-semibold hover:bg-foreground-800 transition-all hover:scale-[1.02] whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
              >
                AllChinaBuy Sheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}